export default `{
    themeGeneralSettings {
      Options {
        contactInfoVideos
      }
    }
  }`;

